/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Property_Legal_HintInputs */

const cs_property_legal_hint = /** @type {(inputs: Property_Legal_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vygenerujte nájemní PDF z účastníků nemovitosti. KYC pole doplňte ručně, pokud v CRM chybí.`)
};

const en_property_legal_hint = /** @type {(inputs: Property_Legal_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Generate a lease PDF from property parties. Override KYC fields when CRM data is incomplete.`)
};

/**
* | output |
* | --- |
* | "Generate a lease PDF from property parties. Override KYC fields when CRM data is incomplete." |
*
* @param {Property_Legal_HintInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const property_legal_hint = /** @type {((inputs?: Property_Legal_HintInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Property_Legal_HintInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_property_legal_hint(inputs)
	return cs_property_legal_hint(inputs)
});